import type {ImageProps, ImageStyle} from "expo-image";
import {Image} from "expo-image";
import {cssInterop} from "nativewind";
import type React from "react";
import {memo} from "react";
import type {StyleProp} from "react-native";

type Props = ImageProps & {
    classNamesInStyle?: StyleProp<ImageStyle>;
};

const ExpoImageWithClassNames: React.FC<Props> = ({style, classNamesInStyle, ...props}) => {
    return <Image {...props} style={[classNamesInStyle, style]} />;
};

export default memo(
    cssInterop(ExpoImageWithClassNames, {
        className: "classNamesInStyle"
    })
);
